// extracted by mini-css-extract-plugin
export default {"pageHeaderStyles":"attendance_pageHeaderStyles__nnrMh","headerParentWrap":"attendance_headerParentWrap__INJ77","headerRightSection":"attendance_headerRightSection__0ka3J"};